var data_selling_plan_id;
var is_data_selling = true;

if($('#subscription-atc-form').length > 0) {
  data_selling_plan_id = $('#subscription-atc-form').find('input:first-child').attr('data-selling-plan');
  
  
  // $('#subscription-atc-form').find('input').click(function(){
  //   if(is_data_selling) {
  //     is_data_selling = false;
  //     $('#subscription-atc-form').find('.add-subscription-to-cart ').prop('disabled', true);
  //   } 
  //   else {
  //     is_data_selling = true;
  //     $('#subscription-atc-form').find('.add-subscription-to-cart ').prop('disabled', false);
  //   }
  // });
}
(function ($) {

  $.fn.addSubscriptionToCart = function (button=false) {
    let btn = $(this);
    let id = 0;
    let sellingPlan = 0;


    let form = btn.closest('form');

    let data = form.serializeArray();
    let feeProd = null;

    data.forEach(function (obj) {
      if (obj.name === 'id') {
        id = obj.value;
      }

      if(obj.name === "properties[_incFeeProd]") {
        feeProd = obj.value;
      }
    });
    if(button) id = $('.add-subscription-to-cart-button').data('id');
    else id = $('.subscription-container__form input').attr('value');
    if(button) {
      feeProd = $('.add-subscription-to-cart-button').data('fee-product');
    }

    sellingPlan = data_selling_plan_id;
    if (id > 0) {
      let dataAdd = {}

      if($('.subscription-container__form input').prop('checked')) {

        dataAdd = {
          "items": [
            {
              "quantity": 1,
              "id": id,
              "selling_plan": sellingPlan
            }
          ]
        };
      } else {
        dataAdd = {
          "items": [
            {
              "quantity": 1,
              "id": id
            }
          ]
        };        
      }

      // Add Fee product to cart
      if( feeProd ) {
        const bundleId = new Date().getTime(); 
        dataAdd.items[0]["properties"] = {
          "_bundleId": bundleId,
          "_bundleProdId": feeProd
        };
        dataAdd.items.push({
          "quantity": 1,
          "id": feeProd,
          "properties": {
            "_bundleId": bundleId,
            "_isFeeProd": 1
          }
        });
      }

      $.post('/cart/add.js', dataAdd, function () {
        window.location = "/cart";
      });
    }
  }

  function clearCart(callback = false) {
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      data: '',
      dataType: 'json',
      success: function () {
        if (typeof callback == 'function') {
          callback();
        } else location.reload();
      },
      error: function (XMLHttpRequest, textStatus) {
        /* error code */
      }
    });
    return false;
  }

  function prepWhatYouGetItems() {
    if($('.section-coaching-what-you-get').length < 1) return;
    let items = $('.section-coaching-what-you-get .item');
    let w = 0;

    items.each(function(){
      let labelW = $(this).find('.label').width();
      if(labelW > w) w = labelW;
    });

    items.each(function(){
      $(this).find('.label').css('min-width', w);
    });

  }

  $(document).on('click', '.add-subscription-to-cart', function (e) {
    e.preventDefault();

    if ( $(this).hasClass('disabled') ) {
      return false; 
    }

    let el = $(this);
    clearCart(function() {
      el.addSubscriptionToCart();
    });
  });

  $(document).on('click', '.add-subscription-to-cart-button', function (e) {
    e.preventDefault();

    if ( $(this).hasClass('disabled') ) {
      return false; 
    }

    let el = $(this);
    clearCart(function() {
      el.addSubscriptionToCart(true);
    });
  });

  $(document).on('change', '#subscription-atc-form input[name="id"]', function() {
    let el = $(this);
    let btn = el.closest('form').find('button');

    btn.html(btn.attr('data-' + el.attr('id') + '-title'));

    if(el.attr('data-available') === 'true') {
      btn.removeAttr('disabled').removeClass('disabled');
    }
    else {
      btn.attr('disabled', 'disabled').addClass('disabled');
    }
  });

  $(function() {
    $('#coaching-what-people-say-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      buttons: true,
      infinite: true,
      nav: true,
      dots: true,
      arrows: true,
      appendArrows: $('.what-people-say__navigation .container'),
      appendDots: $('.what-people-say__navigation .container'),
      prevArrow: '<button type="button" class="slick-prev"></button>',
      nextArrow: '<button type="button" class="slick-next"></button>'
    });

    prepWhatYouGetItems();

  })

  jQuery(window).on('load', function() {
    $('.stories').flickity({
      cellAlign: 'left',
      contain: true,
      pageDots: false
    });

    var customSliderPrevButton = `<button type="button" aria-label="Previous" class="slick-prev red-slider-btn slick-arrow" style=""><span class="icon-arrow-left"></span></button>`;
    var customSliderNextButton = `<button type="button" aria-label="Next" class="slick-next red-slider-btn slick-arrow" style=""><span class="icon-arrow"></span></button>`;

    $('.stories .flickity-button.previous').html(customSliderPrevButton); 
    $('.stories .flickity-button.next').html(customSliderNextButton);

    $('.story').css({'height': '100%'});

    $('#coaching-what-people-say-slider_custom').slick({
      infinite: true,
      prevArrow: '<button type="button" aria-label="Previous" class="slick-prev red-slider-btn slick-arrow" style=""><span class="icon-arrow-left"></span></button>',
      nextArrow: '<button type="button" aria-label="Next" class="slick-next red-slider-btn slick-arrow" style=""><span class="icon-arrow"></span></button>',
      appendArrows: '.coaching-arrows',
      adaptiveHeight: true,
    });

    $('.what-people-say__images-carousel').slick({
      slidesToShow: 3,
      infinite: true,
      slidesToScroll: 1,
      prevArrow: '<button type="button" aria-label"Previous" class="slick-prev red-slider-btn slick-arrow" style=""><span class="icon-arrow-left"></span></button>',
      nextArrow: '<button type="button" aria-label="Next" class="slick-next red-slider-btn slick-arrow" style=""><span class="icon-arrow"></span></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  });

})(jQuery);

window.addEventListener("klaviyoForms", function(e) { 
  if (e.detail.type == 'submit') {
    ga('send', 'event', 'EmailForm', 'Signup', 'Email Signup');
  }
});


$('.tabs-stage .accordion-tabs').hide();
$('.tabs-stage .accordion-tabs:first').show();
$('.tabs-stage .accordion-tabs:first').addClass('active');
$('.tabs-nav li:first').addClass('tab-active');

// Change tab class and display content
$('.tabs-nav a').on('click', function(event){
  event.preventDefault();
  $('.tabs-nav li').removeClass('tab-active');
  $(this).parent().addClass('tab-active');
  $('.tabs-stage .accordion-tabs').hide();
  $('.tabs-stage .accordion-tabs').removeClass('active');
  $($(this).attr('href')).show();
  $($(this).attr('href')).addClass('active');
});

$('#faq-search').on('keyup', function() {
  var value = $(this).val();
  var patt = new RegExp(value, "i");

  if(value) {
    $('.tab-header').hide();
    $('.accordion-tabs').show();
  } else {
    $('.tab-header').show();
    $('.accordion-tabs').hide();
    $('.accordion-tabs.active').show();
  }

  $('.accordion-tabs').find('.event-faq-item').each(function() {
    var $accordion = $(this);

    if ($accordion.find('.event-faq-a').text().search(patt) >= 0 || $accordion.find('.event-faq-q').text().search(patt) >= 0) {
      $(this).show();
    } else {
      $(this).hide();
    }
    
  });
 
});

jQuery(document).ready(function($) {

  $('#klaviyo-flyout-form__step_1_form').on('submit', function(e) {
    e.preventDefault();
    var $form = $(this); 
    let stepNum = parseInt($(this).data('step'));

    if(stepNum <= 1) {
      $('#klaviyo-flyout-form__step_2_form-fields').show();
      $('.klaviyo-flyout-form__step_1_form-fields').hide();
      $('.klaviyo-flyout-form__step_1').hide();
      $('.klaviyo-flyout-form__step_2').show();
      $('#klaviyo-flyout-form_btn').text('Continue');
      $(this).data('step', 2)
      return;
    }

    let productId = $form.find('input[name="id"]').val();
    let first_name = $form.find('input[name="first_name"]').val();
    let last_name = $form.find('input[name="last_name"]').val();
    let email = $form.find('input[name="email"]').val();
    let variant_id = $form.find('input[name="variant_id"]').val();
    let quantity = $form.parent().find('#klaviyo-flyout-form__quantity').val();
    if(typeof productId === 'undefined' || !productId) {
      console.error('There\'s no waitlist product defined');
      return;
    }
    let formData = {
      'items': [{
       'id': productId,
       'quantity': quantity,
       'properties': { '_variant_id': variant_id }
       }]
     };

     fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((res) => res.json())
    .then((res) => {
      if((typeof res.items !== 'undefined') && res.items.length > 0) {
        if(typeof first_name !== 'undefined') {
          sessionStorage.setItem("customer_first_name", first_name);
        }
        if(typeof last_name !== 'undefined') {
          sessionStorage.setItem("customer_last_name", last_name);
        }
        if(typeof email !== 'undefined') {
          sessionStorage.setItem("customer_email", email);
        }
        window.location = "/checkout";
      } else {
        $('#klaviyo-flyout-form_error').text(res.description);
        $('#klaviyo-flyout-form_error').show();
      }
      
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  });

  $(document).on('click', '.template-collection .join-waitlist[data-product-name]', function() {
    let prodName = $(this).data('product-name');
    let prodID = $(this).data('product-id');
    let desc = $(this).data('waitlist-desc');

    if(typeof prodName !== 'undefined' && prodName) {
      $('.klaviyo-flyout-form__event_name').text(prodName);
    }
    if(typeof desc !== 'undefined' && desc) {
      $('.klaviyo-flyout-form__step_2__desc').html(desc);
    }
    if(typeof prodID !== 'undefined' && prodID) {
      $('.klaviyo-flyout-form__step_1_form-fields').append(`<input type="hidden" name="id" value="${prodID}" />`);
    }
  });
  $('a[data-waitlist-desc]').on('click', function() {
    let desc = $(this).data('waitlist-desc');
 
    if(typeof desc !== 'undefined' && desc) {
      $('.klaviyo-flyout-form__step_2__desc').html(desc);
    }

  });

  $("#shopify-section-event-compare-locations-trail").filter(function () {
    return ($(this).children().length === 0)
  }).hide();

  if(document.body.classList.contains('template-product-new-trail') || document.body.classList.contains('template-product-trail-generic') || document.body.classList.contains('template-product-aspen')) {
    var titleElement = document.querySelector(".collection-hero__title");
    var textContent = titleElement.innerHTML;
    textContent = textContent.replace(/(TRAIL)/, '<span class="highlight">$1</span>');
    titleElement.innerHTML = textContent;
  }
});

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

const observer = lozad('.lozad-autoplay', {
  loaded: function(el) {
    el.play();
  }
}); // lazy loads elements with default selector as '.lozad'
observer.observe();

document.addEventListener("DOMContentLoaded", (event) => {
  if (document.querySelectorAll('.event-submission-container').length > 0) {
    const submissionContainers = document.querySelectorAll('.event-submission-container');
    const wrapper = document.createElement('div');
    wrapper.classList.add('event-submission-wrapper');
    submissionContainers.forEach(container => {
      wrapper.appendChild(container);
    });
    document.body.appendChild(wrapper);
    if (document.querySelector('.section-countdown')) {
      const sectionCountdown = document.querySelector('.section-countdown');
      sectionCountdown.insertAdjacentElement('afterend', wrapper);
    }
  }

  if (document.querySelectorAll('.event-details-container').length > 0) {
    const submissionContainers = document.querySelectorAll('.event-details-container');
    const wrapper = document.createElement('div');
    wrapper.classList.add('event-details-wrapper');
    submissionContainers.forEach(container => {
      wrapper.appendChild(container);
    });
    document.body.appendChild(wrapper);
    if (document.querySelector('.section-image-and-text')) {
      const sectionImageAndText = document.querySelector('.section-image-and-text');
      sectionImageAndText.prepend(wrapper);
    }
  }

  if (document.querySelector('[data-lottery-element]')) {
    const lotteryButtons = document.querySelectorAll('[data-lottery-button]');

    lotteryButtons.forEach(function(lotteryButton) {
      lotteryButton.addEventListener('click', (event) => {
        lotteryButtons.forEach(button => {
          button.classList.remove('active-aspen-button');
        });

        lotteryButton.classList.add('active-aspen-button');

        let variantId = lotteryButton.getAttribute('data-variant-id');
        let sellingPlanId = lotteryButton.getAttribute('data-selling-plan-id');
        let entryName = lotteryButton.getAttribute('data-name');

        let variantIdInput = document.querySelector('[data-form-event] input[name="id"]');
        let sellingPlanInput = document.querySelector('[data-form-event] input[name="selling_plan"]');
        let entryNameInput = document.querySelector('[data-form-event] [data-entry-input]');

        variantIdInput.value = variantId;
        entryNameInput.value = entryName;

        if (sellingPlanId != null) {
          sellingPlanInput.value = sellingPlanId;
        } else {
          sellingPlanInput.value = '';
        }

        document.querySelector('.btn--aspen-product[type="submit"]').removeAttribute('disabled');
      });
    });

    // document.querySelector('.btn--aspen-product[type="submit"]').addEventListener('click', (event) => {
    //   console.log('button clicked');
    //   let sellingPlanInput = document.querySelector('[data-form-event] input[name="selling_plan"]');
    //   if (sellingPlanInput.value === '') {
    //     event.preventDefault();
    //     const errorMessage = document.createElement('p');
    //     errorMessage.textContent = 'Please choose an option';
    //     errorMessage.style.color = 'red';
    //     errorMessage.style.marginTop = '10px';
        
    //     // Remove any existing error message first
    //     const existingError = document.querySelector('.lottery-error-message');
    //     if (existingError) {
    //       existingError.remove();
    //     }
        
    //     errorMessage.classList.add('lottery-error-message');
    //     event.target.parentNode.appendChild(errorMessage);
    //     return;
    //   }
    // });
  }

})

/** 
 * Fee product addon
 */
document.addEventListener("DOMContentLoaded", async function () {
  try {
      // Fetch the current cart data
      const response = await fetch('/cart.js');
      const cart = await response.json();
      let cartUpdated = false;

      if (!cart.items || cart.items.length === 0) {
          return;
      }

      const bundleGroups = {};
      const itemsToAdd = [];
      const itemsToRemove = [];

      // Step 1: Organize items by _bundleId
      cart.items.forEach((item, index) => {
          if (item.properties && item.properties._bundleId) {
              const bundleId = item.properties._bundleId;

              if (!bundleGroups[bundleId]) {
                  bundleGroups[bundleId] = [];
              }
              bundleGroups[bundleId].push({ ...item, line: index + 1 });
          }
      });

      // Step 2: Loop through items to check for missing bundle products or orphaned fee products
      cart.items.forEach((item, index) => {
          if (!item.properties) return;

          const bundleId = item.properties._bundleId;

          // If an item has _bundleProdId but no matching _bundleId items, add feee product
          if (item.properties._bundleProdId && (!bundleGroups[bundleId] || bundleGroups[bundleId].length === 1)) {
              itemsToAdd.push(item.properties._bundleProdId);
          }

          // If an item has _isFeeProd and no matching _bundleId items, remove fee product
          if (item.properties._isFeeProd && (!bundleGroups[bundleId] || bundleGroups[bundleId].length === 1)) {
              itemsToRemove.push(item.key); // Shopify uses 1-based index for line items
          }
      });

      // Step 3: Add missing bundle products
      if (itemsToAdd.length > 0) {
          await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: itemsToAdd.map(id => ({ id, quantity: 1 })) })
          });
          cartUpdated = true;
      }

      // Step 4: Remove orphaned fee products
      if (itemsToRemove.length > 0) {
          const updates = {};
          itemsToRemove.forEach(line => updates[line] = 0);

          await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates })
          });
          cartUpdated = true;
      }

      if (cartUpdated) {
        window.location.reload();
      }

  } catch (error) {
      console.error("Error managing Shopify cart:", error);
  }
});


// Find  fee product bundle
async function getBundleItems(bundleId) {
  try {
      // Fetch Shopify cart data
      const response = await fetch('/cart.js');
      const cart = await response.json();

      // Ensure cart items exist
      if (!cart.items || cart.items.length === 0) {
          return [];
      }
      // Loop through cart items and find matching _bundleId
      const result = cart.items
          .map((item, index) => ({
              index: index + 1 ,
              line: item.key,
              quantity: item.quantity
          }))
          .filter(item => cart.items[item.index - 1].properties && cart.items[item.index - 1].properties._bundleId == bundleId);

      return result;
  } catch (error) {
      console.error('Error fetching cart data:', error);
      return [];
  }
}

// GTM Klavio Lead Conversion Tracker
window.addEventListener("klaviyoForms", function (e) {
  if (e.detail.type == 'submit') {
    const dataArray = {
      event: 'klaviyo_lead_submit',
      formId: e.detail.formId,
      formVersionId: e.detail.formVersionId,
      email: e.detail.metaData?.$email || undefined,
      phone: e.detail.metaData?.$phone_number || undefined,
      source: e.detail.metaData?.$source || undefined
    }

    if (dataArray.formId == 'QYzxja' && dataArray.email) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(dataArray);
      console.log('Klaviyo Lead Conversion Tracker Data Layer Push:', dataArray);
    }

    // Only for footer form
    if (dataArray.formId == 'WJWT3T' && dataArray.email) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(dataArray);
      console.log('Klaviyo Lead Conversion Tracker Data Layer Push:', dataArray);
    }
  }
});